import {createAction} from '@reduxjs/toolkit'
import {
  SearchUsersGroupsItem,
  UserGroupDetailsState,
  ShowUserGroupDetailPayload,
} from 'interfaces'

const getSearchUsersGroups = createAction<{
  text: string
  models: string[]
}>('getSearchUsersGroups')
const getSearchUsersGroupsFailure = createAction<string>(
  'getSearchUsersGroupsFailure',
)
const getSearchUsersGroupsSuccess = createAction<SearchUsersGroupsItem[]>(
  'getSearchUsersGroupsSuccess',
)
const resetSearch = createAction('resetSearch')
const setShowUserGroupDetails = createAction<ShowUserGroupDetailPayload>(
  'setShowUserGroupDetails',
)
const getUserGroupDetails = createAction<string>('getUserGroupDetails')
const getUserGroupDetailsSuccess = createAction<UserGroupDetailsState>(
  'getUserGroupDetailsSuccess',
)
const getUserGroupDetailsFailure = createAction<string>(
  'getUserGroupDetailsFailure',
)
export {
  getSearchUsersGroups,
  getSearchUsersGroupsFailure,
  getSearchUsersGroupsSuccess,
  resetSearch,
  setShowUserGroupDetails,
  getUserGroupDetails,
  getUserGroupDetailsSuccess,
  getUserGroupDetailsFailure,
}
